import { Typography } from '@atlas-metrics/design-system';
import Image from 'next/image';
import React from 'react';

import clsxm from '@/lib/clsxm';

import { Content } from '../ui/layout';

export interface IProps {
  avatar: React.ReactNode;
  companyName: string;
  companyDescription: string;
  backgroundColor: string;
  largeHeaderUrl: string | undefined;
  smallHeaderUrl: string | undefined;
}

const CompanyHeader: React.FC<IProps> = ({
  companyName,
  companyDescription,
  avatar,
  backgroundColor,
  largeHeaderUrl,
  smallHeaderUrl,
}) => {
  return (
    <div className={clsxm('z-10  w-full')}>
      <div
        style={{
          backgroundColor,
        }}
        className={clsxm('h-[160px] w-full bg-ds-purple-700')}
      >
        {smallHeaderUrl && (
          <Image
            height={160}
            width={1440}
            alt='custom_header'
            src={smallHeaderUrl}
            className='mx-auto h-[160px] w-full max-w-[1440px] flex-shrink-0 object-cover webS:hidden'
          />
        )}
        {largeHeaderUrl && (
          <Image
            height={160}
            width={1440}
            alt='custom_header'
            src={largeHeaderUrl}
            className={clsxm(
              'mx-auto h-[160px] w-full max-w-[1440px] flex-shrink-0 object-cover webM:!w-fit',
              // smallHeaderUrl is optional, so we need to hide the large header if smallHeaderUrl is present
              smallHeaderUrl && 'hidden webS:!block'
            )}
          />
        )}
      </div>
      <div className='shadow-overlay'>
        <Content type='body'>
          <div className='sticky z-[15] mb-7 mt-[-60px] flex h-[120px] w-[120px] items-center justify-center rounded-full border-[8px] border-white bg-ds-grey-200 shadow-raised'>
            {avatar}
          </div>
          <div className='z-10 mb-2 text-h4 font-semibold'>{companyName}</div>
          <div id='company-description' className='pb-3'>
            <Typography variant='body-m' bold className='text-ds-grey-700'>
              {companyDescription}
            </Typography>
          </div>
        </Content>
      </div>
    </div>
  );
};
export default CompanyHeader;
